<template>
  <span class="logo-text" :class="size">
    <span class="logo-take">Tak<span class="logo-last-letter">e</span></span
    ><span class="logo-fav">Fav</span>
  </span>
</template>

<script setup lang="ts">
interface Props {
  size?: 'small' | 'medium' | 'large'
}

withDefaults(defineProps<Props>(), {
  size: 'medium',
})
</script>

<style lang="scss" scoped>
.logo-text {
  font-weight: bold;
  display: inline-block;

  &.small {
    font-size: 1rem;
  }

  &.medium {
    font-size: 1.5rem;
  }

  &.large {
    font-size: 2rem;
  }
}

.logo-take {
  color: #555; // Dark color
  margin: 1px 2px 1px 0;
}

.logo-fav {
  color: #cd4243; // Red color
}

.logo-last-letter {
  color: #ffd700; // Yellow color (matching Header's brand-last-letter)
  rotate: 336deg;
  display: inline-block;
}
</style>
